<template>
  <Dialog 
    v-model="visible" 
    :title="'Missing Patient’s DOB'"
    class="dob-dialog"
  >
    <p style="margin-bottom:16px;">The patient’s date of birth is required to proceed.</p>
    <div class="dob-input-wrap">
      <Input
        :modelValue="dob"
        @update:modelValue="onDobInput"
        :InputTitle="'Patient’s Date of Birth'"
        :isRequiredText="'Required'"
        placeholder="MM/DD/YYYY"
      />
    </div>
    <div class="dob-dashed"></div>
    <div class="dob-actions">
      <Button colorType="none-stroke" @click="onUnknownDob">Don’t know the patient’s DOB?</Button>
      <Button colorType="dark-blue" :disabled="!isValid" @click="submit">Submit</Button>
    </div>
  </Dialog>
</template>

<script>
import Dialog from '@/NewLibrary/Dialog.vue'
import Input from '@/NewLibrary/Input.vue'
import Button from '@/NewLibrary/Button.vue'

export default {
  name: 'DobDialog',
  components: { Dialog, Input, Button },
  props: {
    modelValue: { type: Boolean, default: false },
    initialDob: { type: String, default: '' },
  },
  emits: ['update:modelValue','submit','unknown-dob'],
  data() {
    return { dob: this.initialDob }
  },
  computed: {
    visible: {
      get() { return this.modelValue },
      set(v) { this.$emit('update:modelValue', v) }
    },
    isValid() {
      if (!/^\d{2}\/\d{2}\/\d{4}$/.test(this.dob)) return false
      const [mStr, dStr, yStr] = this.dob.split('/')
      const m = Number(mStr)
      const d = Number(dStr)
      const y = Number(yStr)
      if (m < 1 || m > 12) return false
      if (d < 1 || d > 31) return false
      if (y < 1900) return false
      const now = new Date()
      const dt  = new Date(y, m - 1, d)
      if (isNaN(dt.getTime())) return false
      if (dt.getFullYear() !== y || dt.getMonth() + 1 !== m || dt.getDate() !== d) return false
      if (dt > new Date(now.getFullYear(), now.getMonth(), now.getDate())) return false
      return true
    }
  },
  methods: {
    onDobInput(raw) {
      const digits = String(raw || '').replace(/\D/g, '').slice(0, 8)
      if (digits.length <= 2) {
        this.dob = digits
      } else if (digits.length <= 4) {
        this.dob = `${digits.slice(0,2)}/${digits.slice(2)}`
      } else {
        this.dob = `${digits.slice(0,2)}/${digits.slice(2,4)}/${digits.slice(4)}`
      }
    },
    submit() {
      if (!this.isValid) return
      this.$emit('submit', this.dob)
      this.visible = false
    },
    onUnknownDob() {
      this.visible = false
      this.$emit('unknown-dob')
    }
  }
}
</script>

<style scoped>
.dob-input-wrap {
  width: 360px;
  height: 85px;
  margin: auto;
  justify-content: center;
}

.dob-dashed {
  border-bottom: 1px dashed #C8CDD3;
  height: 0;
  margin-top: 6px;
}

.dob-actions {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin-top: 16px;
}
</style>
